import React from 'react';

import SofologyLogo from '../layout/graphics/SofologyLogo';

function CardTitlePart({ title }) {
  return (title !== undefined || title !== null) && (
    <div className="card__title">
      <SofologyLogo />
      <span>
        {title}
      </span>
    </div>
  );
}

export default CardTitlePart;



// WEBPACK FOOTER //
// ./src/parts/CardTitlePart.js